// Remember: Facets need to be added to Algolia index settings
import { FilterConfig } from "@secureo/common/typings/Algolia"

// https://www.algolia.com/doc/api-reference/widgets/refinement-list/react/#widget-param-limit
export const checkboxFilterLimit = 20

const grossPriceCents: FilterConfig = {
	attribute: "grossPriceCents",
	label: "Preis (€)",
	type: "range",
	step: 1000,
	hideInBusinessVersion: true,
}

const manufacturer: FilterConfig = {
	attribute: "manufacturer",
	label: "Hersteller",
	type: "checkbox",
}

const system: FilterConfig = {
	attribute: "System",
	label: "System",
	type: "checkbox",
}

export const categoryPageFilters: FilterConfig[] = [
	grossPriceCents,
	manufacturer,
	system,
	{
		attribute: "Systemtyp",
		label: "Systemtyp",
		type: "checkbox",
	},
	{
		attribute: "Sicherheitslevel",
		label: "Sicherheitslevel",
		type: "range",
		hint: "Das SafeHero Sicherheitslevel zeigt einfach und bequem über welchen Sicherheitsstandard das Produkt verfügt - 1 bezeichnet dabei Basis-Sicherheit, 10 beschreibt maximale Sicherheit.",
	},
	{
		attribute: "Zylinderart",
		label: "Zylinderart",
		type: "checkbox",
		hint: "Neben den standardmäßigen Doppel- oder Knaufzylindern stehen eine Reihe von weiteren Zylinderarten für die unterschiedlichsten Anwendungsbereiche zur Auswahl.",
	},
	{
		attribute: "Patentlaufzeit",
		label: "Patentlaufzeit",
		type: "range",
		hint: "Eine möglichst lange Patentlaufzeit ist eine wichtige Voraussetzung für den Kauf eines Schließsystems. Sie bezeichnet den rechtlichen Kopierschutz des Systems und gewährleistet, dass Schlüssel nur durch Vorlage der Sicherungskarte nachgemacht werden können.",
	},
	{
		attribute: "Wendeschlüssel",
		label: "Wendeschlüssel",
		type: "toggle",
	},
	{
		attribute: "Zylinderfarbe",
		label: "Zylinderfarbe",
		type: "checkbox",
	},
	{
		attribute: "Schloss-Typ",
		label: "Schloss-Typ",
		type: "checkbox",
		hint: "Wendeschlüssel erleichtern das Anstecken des Schlüssels am Zylinder und erhöhen den Komfort ungemein. Sie können im Gegensatz zu einseitig gefrästen Schlüsseln unabhängig von der Schlüsselseite eingeführt werden.",
	},
	{
		attribute: "Produktart",
		label: "Produktart",
		type: "checkbox",
	},
	{
		attribute: "Medien",
		label: "Medien",
		type: "checkbox",
		hint: "Hier können Sie speziell nach Ihrem bevorzugten Medium suchen, mit dem das neue Zutrittssystem gesperrt werden soll.",
	},
	{
		attribute: "numberOfKeyHooks",
		label: "Anzahl Schlüsselhaken",
		type: "range",
	},
	{
		attribute: "color",
		label: "Farbe",
		type: "checkbox",
	},
]

export const searchPageFilters: FilterConfig[] = categoryPageFilters

export const brandPageFilters: FilterConfig[] = categoryPageFilters.filter(
	(filter) => filter.attribute !== "manufacturer",
)

export const lockingSystemFilters: FilterConfig[] = [
	{
		attribute: "securityScore",
		label: "Sicherheitsstufe",
		type: "range",
	},
]
